// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../server/config/ads';
import { buildPostAdModel } from '../../utils/ad_util';

export default function(state = {}, action) {
  const store = action.store;
  const typeMap = {
    HOMEPAGE_LOADING() {
      return {
        isLoading: true,
        homepage: action.homepage
      };
    },
    HOMEPAGE_LOADED() {
      // For future, the topic needs to be passed here,
      // to determine which topic page you're on, the adzone for topic will be
      // 'topicName/topicName', no need to look it up in keymap
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(adsConfig, site, null, 'homepage');

      return {
        isLoading: false,
        data: get(action, 'homepage'),
        ads: adModelData
      };
    },
    HOMEPAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.homepage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/homepage_reducer.js